module.exports = __webpack_public_path__ + "static/media/brand1.0da5fe9a.png";